export const VERSION = "1.8.3";